/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FavoriteHotel,
  FavoriteHotelCollection,
  FavoriteHotelMembershipRequest,
  FavoriteHotelMembershipResponse,
  FavoriteHotelMutationResponse,
  PortfolioOptimizationRequest,
  PortfolioOptimizationResult,
  RecentHotel,
  RecentHotelCollection,
  RecentHotelViewRequest,
  SearchPromptRequest,
  SearchPromptResponse,
  SearchRequestV2,
  SearchRequestV3,
  SearchSessionCollection,
  SearchSessionV2,
  SearchSessionV2ResultsHotels,
  SearchSessionV3,
  SuggestedSearchResponse,
  SuggestedSearchesResponse,
} from '../models/index';
import {
    FavoriteHotelFromJSON,
    FavoriteHotelToJSON,
    FavoriteHotelCollectionFromJSON,
    FavoriteHotelCollectionToJSON,
    FavoriteHotelMembershipRequestFromJSON,
    FavoriteHotelMembershipRequestToJSON,
    FavoriteHotelMembershipResponseFromJSON,
    FavoriteHotelMembershipResponseToJSON,
    FavoriteHotelMutationResponseFromJSON,
    FavoriteHotelMutationResponseToJSON,
    PortfolioOptimizationRequestFromJSON,
    PortfolioOptimizationRequestToJSON,
    PortfolioOptimizationResultFromJSON,
    PortfolioOptimizationResultToJSON,
    RecentHotelFromJSON,
    RecentHotelToJSON,
    RecentHotelCollectionFromJSON,
    RecentHotelCollectionToJSON,
    RecentHotelViewRequestFromJSON,
    RecentHotelViewRequestToJSON,
    SearchPromptRequestFromJSON,
    SearchPromptRequestToJSON,
    SearchPromptResponseFromJSON,
    SearchPromptResponseToJSON,
    SearchRequestV2FromJSON,
    SearchRequestV2ToJSON,
    SearchRequestV3FromJSON,
    SearchRequestV3ToJSON,
    SearchSessionCollectionFromJSON,
    SearchSessionCollectionToJSON,
    SearchSessionV2FromJSON,
    SearchSessionV2ToJSON,
    SearchSessionV2ResultsHotelsFromJSON,
    SearchSessionV2ResultsHotelsToJSON,
    SearchSessionV3FromJSON,
    SearchSessionV3ToJSON,
    SuggestedSearchResponseFromJSON,
    SuggestedSearchResponseToJSON,
    SuggestedSearchesResponseFromJSON,
    SuggestedSearchesResponseToJSON,
} from '../models/index';

export interface FavoritesHotelsGetRequest {
    limit?: number;
    cursor?: string;
}

export interface FavoritesHotelsMembershipPostRequest {
    favoriteHotelMembershipRequest: FavoriteHotelMembershipRequest;
}

export interface FavoritesHotelsPropertyIdDeleteRequest {
    propertyId: number;
}

export interface FavoritesHotelsPropertyIdPutRequest {
    propertyId: number;
}

export interface RecentHotelsGetRequest {
    limit?: number;
    cursor?: string;
}

export interface RecentHotelsPutRequest {
    recentHotelViewRequest: RecentHotelViewRequest;
}

export interface SearchPromptPostRequest {
    searchPromptRequest?: SearchPromptRequest;
}

export interface SuggestedSearchesGetRequest {
    searchTypes?: Array<SuggestedSearchesGetSearchTypesEnum>;
    limit?: number;
}

export interface SuggestedSearchesSuggestedSearchIdGetRequest {
    suggestedSearchId: string;
    refresh?: boolean;
}

export interface V2SearchPostRequest {
    searchRequestV2?: SearchRequestV2;
}

export interface V2SearchSearchSessionIdContentGetRequest {
    searchSessionId: string;
}

export interface V2SearchSearchSessionIdGetRequest {
    searchSessionId: string;
}

export interface V2SearchSearchSessionIdRatesStreamGetRequest {
    searchSessionId: string;
}

export interface V2SearchSearchSessionIdStreamGetRequest {
    searchSessionId: string;
}

export interface V3PortfolioOptimizePostRequest {
    portfolioOptimizationRequest: PortfolioOptimizationRequest;
}

export interface V3SearchPostRequest {
    searchRequestV3?: SearchRequestV3;
}

export interface V3SearchSearchSessionIdGetRequest {
    searchSessionId: string;
}

/**
 * 
 */
export class SearchApi extends runtime.BaseAPI {

    /**
     * Returns the caller\'s favorite hotels in newest-first order.
     */
    async favoritesHotelsGetRaw(requestParameters: FavoritesHotelsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FavoriteHotelCollection>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/favorites/hotels`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FavoriteHotelCollectionFromJSON(jsonValue));
    }

    /**
     * Returns the caller\'s favorite hotels in newest-first order.
     */
    async favoritesHotelsGet(requestParameters: FavoritesHotelsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FavoriteHotelCollection> {
        const response = await this.favoritesHotelsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the subset of requested property IDs favorited by the caller.
     */
    async favoritesHotelsMembershipPostRaw(requestParameters: FavoritesHotelsMembershipPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FavoriteHotelMembershipResponse>> {
        if (requestParameters['favoriteHotelMembershipRequest'] == null) {
            throw new runtime.RequiredError(
                'favoriteHotelMembershipRequest',
                'Required parameter "favoriteHotelMembershipRequest" was null or undefined when calling favoritesHotelsMembershipPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/favorites/hotels/membership`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FavoriteHotelMembershipRequestToJSON(requestParameters['favoriteHotelMembershipRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FavoriteHotelMembershipResponseFromJSON(jsonValue));
    }

    /**
     * Returns the subset of requested property IDs favorited by the caller.
     */
    async favoritesHotelsMembershipPost(requestParameters: FavoritesHotelsMembershipPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FavoriteHotelMembershipResponse> {
        const response = await this.favoritesHotelsMembershipPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Idempotently removes a hotel from the caller\'s favorites.
     */
    async favoritesHotelsPropertyIdDeleteRaw(requestParameters: FavoritesHotelsPropertyIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FavoriteHotelMutationResponse>> {
        if (requestParameters['propertyId'] == null) {
            throw new runtime.RequiredError(
                'propertyId',
                'Required parameter "propertyId" was null or undefined when calling favoritesHotelsPropertyIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/favorites/hotels/{property_id}`;
        urlPath = urlPath.replace(`{${"property_id"}}`, encodeURIComponent(String(requestParameters['propertyId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FavoriteHotelMutationResponseFromJSON(jsonValue));
    }

    /**
     * Idempotently removes a hotel from the caller\'s favorites.
     */
    async favoritesHotelsPropertyIdDelete(requestParameters: FavoritesHotelsPropertyIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FavoriteHotelMutationResponse> {
        const response = await this.favoritesHotelsPropertyIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Idempotently adds a hotel to the caller\'s favorites.
     */
    async favoritesHotelsPropertyIdPutRaw(requestParameters: FavoritesHotelsPropertyIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FavoriteHotel>> {
        if (requestParameters['propertyId'] == null) {
            throw new runtime.RequiredError(
                'propertyId',
                'Required parameter "propertyId" was null or undefined when calling favoritesHotelsPropertyIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/favorites/hotels/{property_id}`;
        urlPath = urlPath.replace(`{${"property_id"}}`, encodeURIComponent(String(requestParameters['propertyId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FavoriteHotelFromJSON(jsonValue));
    }

    /**
     * Idempotently adds a hotel to the caller\'s favorites.
     */
    async favoritesHotelsPropertyIdPut(requestParameters: FavoritesHotelsPropertyIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FavoriteHotel> {
        const response = await this.favoritesHotelsPropertyIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the caller\'s recently viewed active hotels in newest-first paginated order.
     */
    async recentHotelsGetRaw(requestParameters: RecentHotelsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RecentHotelCollection>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/recent/hotels`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RecentHotelCollectionFromJSON(jsonValue));
    }

    /**
     * Returns the caller\'s recently viewed active hotels in newest-first paginated order.
     */
    async recentHotelsGet(requestParameters: RecentHotelsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RecentHotelCollection> {
        const response = await this.recentHotelsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Records a hotel detail view for the caller. Repeated views update the existing hotel entry.
     */
    async recentHotelsPutRaw(requestParameters: RecentHotelsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RecentHotel>> {
        if (requestParameters['recentHotelViewRequest'] == null) {
            throw new runtime.RequiredError(
                'recentHotelViewRequest',
                'Required parameter "recentHotelViewRequest" was null or undefined when calling recentHotelsPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/recent/hotels`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: RecentHotelViewRequestToJSON(requestParameters['recentHotelViewRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RecentHotelFromJSON(jsonValue));
    }

    /**
     * Records a hotel detail view for the caller. Repeated views update the existing hotel entry.
     */
    async recentHotelsPut(requestParameters: RecentHotelsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RecentHotel> {
        const response = await this.recentHotelsPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns prompt-related information for the current search in progress
     */
    async recentSearchesGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchSessionCollection>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/recent/searches`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchSessionCollectionFromJSON(jsonValue));
    }

    /**
     * Returns prompt-related information for the current search in progress
     */
    async recentSearchesGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchSessionCollection> {
        const response = await this.recentSearchesGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns prompt-related information for the current search in progress
     */
    async searchPromptPostRaw(requestParameters: SearchPromptPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchPromptResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/search/prompt`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchPromptRequestToJSON(requestParameters['searchPromptRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchPromptResponseFromJSON(jsonValue));
    }

    /**
     * Returns prompt-related information for the current search in progress
     */
    async searchPromptPost(requestParameters: SearchPromptPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchPromptResponse> {
        const response = await this.searchPromptPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get suggested searches
     */
    async suggestedSearchesGetRaw(requestParameters: SuggestedSearchesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuggestedSearchesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['searchTypes'] != null) {
            queryParameters['search_types'] = requestParameters['searchTypes'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/suggested_searches`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuggestedSearchesResponseFromJSON(jsonValue));
    }

    /**
     * Get suggested searches
     */
    async suggestedSearchesGet(requestParameters: SuggestedSearchesGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuggestedSearchesResponse> {
        const response = await this.suggestedSearchesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get suggested search
     */
    async suggestedSearchesSuggestedSearchIdGetRaw(requestParameters: SuggestedSearchesSuggestedSearchIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuggestedSearchResponse>> {
        if (requestParameters['suggestedSearchId'] == null) {
            throw new runtime.RequiredError(
                'suggestedSearchId',
                'Required parameter "suggestedSearchId" was null or undefined when calling suggestedSearchesSuggestedSearchIdGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['refresh'] != null) {
            queryParameters['refresh'] = requestParameters['refresh'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/suggested_searches/{suggested_search_id}`;
        urlPath = urlPath.replace(`{${"suggested_search_id"}}`, encodeURIComponent(String(requestParameters['suggestedSearchId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuggestedSearchResponseFromJSON(jsonValue));
    }

    /**
     * Get suggested search
     */
    async suggestedSearchesSuggestedSearchIdGet(requestParameters: SuggestedSearchesSuggestedSearchIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuggestedSearchResponse> {
        const response = await this.suggestedSearchesSuggestedSearchIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a session id for the given search. Querying for this session id will return the results of the search.
     */
    async v2SearchPostRaw(requestParameters: V2SearchPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchSessionV2>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v2/search`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchRequestV2ToJSON(requestParameters['searchRequestV2']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchSessionV2FromJSON(jsonValue));
    }

    /**
     * Returns a session id for the given search. Querying for this session id will return the results of the search.
     */
    async v2SearchPost(requestParameters: V2SearchPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchSessionV2> {
        const response = await this.v2SearchPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * GON-6020: the ranked property CONTENT for a search, available up front (before live rates). Returns every viewport property as a content-only HotelSummary (no rate fields populated) sorted by the recommendation order, so the client can render the full list immediately and stream rates in afterwards (see `/v2/search/{search_session_id}/rates/stream`). Items are empty until the orchestrator has computed content for the session — clients poll until populated. 
     */
    async v2SearchSearchSessionIdContentGetRaw(requestParameters: V2SearchSearchSessionIdContentGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchSessionV2ResultsHotels>> {
        if (requestParameters['searchSessionId'] == null) {
            throw new runtime.RequiredError(
                'searchSessionId',
                'Required parameter "searchSessionId" was null or undefined when calling v2SearchSearchSessionIdContentGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v2/search/{search_session_id}/content`;
        urlPath = urlPath.replace(`{${"search_session_id"}}`, encodeURIComponent(String(requestParameters['searchSessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchSessionV2ResultsHotelsFromJSON(jsonValue));
    }

    /**
     * GON-6020: the ranked property CONTENT for a search, available up front (before live rates). Returns every viewport property as a content-only HotelSummary (no rate fields populated) sorted by the recommendation order, so the client can render the full list immediately and stream rates in afterwards (see `/v2/search/{search_session_id}/rates/stream`). Items are empty until the orchestrator has computed content for the session — clients poll until populated. 
     */
    async v2SearchSearchSessionIdContentGet(requestParameters: V2SearchSearchSessionIdContentGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchSessionV2ResultsHotels> {
        const response = await this.v2SearchSearchSessionIdContentGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the results of a search
     */
    async v2SearchSearchSessionIdGetRaw(requestParameters: V2SearchSearchSessionIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchSessionV2>> {
        if (requestParameters['searchSessionId'] == null) {
            throw new runtime.RequiredError(
                'searchSessionId',
                'Required parameter "searchSessionId" was null or undefined when calling v2SearchSearchSessionIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v2/search/{search_session_id}`;
        urlPath = urlPath.replace(`{${"search_session_id"}}`, encodeURIComponent(String(requestParameters['searchSessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchSessionV2FromJSON(jsonValue));
    }

    /**
     * Returns the results of a search
     */
    async v2SearchSearchSessionIdGet(requestParameters: V2SearchSearchSessionIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchSessionV2> {
        const response = await this.v2SearchSearchSessionIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * GON-6020: server-sent-events stream of live RATE deltas for a search, keyed by `vervotech_property_id`. Pairs with `/v2/search/{id}/content` (which returns the ranked content up front): clients render the full content list immediately, then merge these rate deltas into the matching cards in place — so the list never reshuffles. Emits `batch_start` once, then one `rates` event per completed batch, then a terminal `complete` (aggregates only — the content list is already client-side) or `error`. 
     */
    async v2SearchSearchSessionIdRatesStreamGetRaw(requestParameters: V2SearchSearchSessionIdRatesStreamGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['searchSessionId'] == null) {
            throw new runtime.RequiredError(
                'searchSessionId',
                'Required parameter "searchSessionId" was null or undefined when calling v2SearchSearchSessionIdRatesStreamGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v2/search/{search_session_id}/rates/stream`;
        urlPath = urlPath.replace(`{${"search_session_id"}}`, encodeURIComponent(String(requestParameters['searchSessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * GON-6020: server-sent-events stream of live RATE deltas for a search, keyed by `vervotech_property_id`. Pairs with `/v2/search/{id}/content` (which returns the ranked content up front): clients render the full content list immediately, then merge these rate deltas into the matching cards in place — so the list never reshuffles. Emits `batch_start` once, then one `rates` event per completed batch, then a terminal `complete` (aggregates only — the content list is already client-side) or `error`. 
     */
    async v2SearchSearchSessionIdRatesStreamGet(requestParameters: V2SearchSearchSessionIdRatesStreamGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.v2SearchSearchSessionIdRatesStreamGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Server-sent-events stream of the hotel search results. Replaces client polling: instead of re-fetching the entire session every 2s, the server pushes per-batch events as provider fan-out completes. Emits `batch_start` once, then one `hotels` event per completed batch, then a terminal `complete` or `error` event. 
     */
    async v2SearchSearchSessionIdStreamGetRaw(requestParameters: V2SearchSearchSessionIdStreamGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['searchSessionId'] == null) {
            throw new runtime.RequiredError(
                'searchSessionId',
                'Required parameter "searchSessionId" was null or undefined when calling v2SearchSearchSessionIdStreamGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v2/search/{search_session_id}/stream`;
        urlPath = urlPath.replace(`{${"search_session_id"}}`, encodeURIComponent(String(requestParameters['searchSessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Server-sent-events stream of the hotel search results. Replaces client polling: instead of re-fetching the entire session every 2s, the server pushes per-batch events as provider fan-out completes. Emits `batch_start` once, then one `hotels` event per completed batch, then a terminal `complete` or `error` event. 
     */
    async v2SearchSearchSessionIdStreamGet(requestParameters: V2SearchSearchSessionIdStreamGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.v2SearchSearchSessionIdStreamGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Optimizes a user\'s loyalty portfolio for a specific trip, returning ranked cross-chain hotel recommendations. 
     */
    async v3PortfolioOptimizePostRaw(requestParameters: V3PortfolioOptimizePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortfolioOptimizationResult>> {
        if (requestParameters['portfolioOptimizationRequest'] == null) {
            throw new runtime.RequiredError(
                'portfolioOptimizationRequest',
                'Required parameter "portfolioOptimizationRequest" was null or undefined when calling v3PortfolioOptimizePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v3/portfolio/optimize`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PortfolioOptimizationRequestToJSON(requestParameters['portfolioOptimizationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortfolioOptimizationResultFromJSON(jsonValue));
    }

    /**
     * Optimizes a user\'s loyalty portfolio for a specific trip, returning ranked cross-chain hotel recommendations. 
     */
    async v3PortfolioOptimizePost(requestParameters: V3PortfolioOptimizePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortfolioOptimizationResult> {
        const response = await this.v3PortfolioOptimizePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a session id for the given search. Querying for this session id will return the results of the search.
     */
    async v3SearchPostRaw(requestParameters: V3SearchPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchSessionV3>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v3/search`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchRequestV3ToJSON(requestParameters['searchRequestV3']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchSessionV3FromJSON(jsonValue));
    }

    /**
     * Returns a session id for the given search. Querying for this session id will return the results of the search.
     */
    async v3SearchPost(requestParameters: V3SearchPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchSessionV3> {
        const response = await this.v3SearchPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the results of a search
     */
    async v3SearchSearchSessionIdGetRaw(requestParameters: V3SearchSearchSessionIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchSessionV3>> {
        if (requestParameters['searchSessionId'] == null) {
            throw new runtime.RequiredError(
                'searchSessionId',
                'Required parameter "searchSessionId" was null or undefined when calling v3SearchSearchSessionIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("common_auth", []);
        }


        let urlPath = `/v3/search/{search_session_id}`;
        urlPath = urlPath.replace(`{${"search_session_id"}}`, encodeURIComponent(String(requestParameters['searchSessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchSessionV3FromJSON(jsonValue));
    }

    /**
     * Returns the results of a search
     */
    async v3SearchSearchSessionIdGet(requestParameters: V3SearchSearchSessionIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchSessionV3> {
        const response = await this.v3SearchSearchSessionIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const SuggestedSearchesGetSearchTypesEnum = {
    UpcomingTrips: 'upcoming trips',
    RecentSearches: 'recent searches',
    PopularDestinations: 'popular destinations',
    UpcomingHolidays: 'upcoming holidays',
    PopularOnGondola: 'popular on gondola'
} as const;
export type SuggestedSearchesGetSearchTypesEnum = typeof SuggestedSearchesGetSearchTypesEnum[keyof typeof SuggestedSearchesGetSearchTypesEnum];
